// extracted by mini-css-extract-plugin
module.exports = {"footer_main":"Footer_footer_main__1D6rM","handles":"Footer_handles__1R5o9","credit":"Footer_credit__3O9iI"};